<template>
  <v-app>
    <Header />
    <Sidebar />
    <v-main class="content mx-0 mx-md-2 pt-16">
      <!-- <Breadcrumbs /> -->
      <v-container fluid class="mx-1 mt-2" v-if="isLoadedApp">
        <router-view />
      </v-container>
      <Footer />
      <!-- <Helper /> -->
        <work-space-create-modal/>
        <work-space-invite-dialog/>
    </v-main>
    <notification></notification>
    <v-overlay :value="!isLoadedApp">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
    import * as utils from '@/plugins/utils';
    import Notification from '@/app/components/Notification';
    import Header from '@/components/Header/Header';
    import Sidebar from '@/components/Sidebar/Sidebar';
    import Footer from "@/components/Footer/Footer";
    // import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
    // import Helper from "@/components/Helper/Helper";
    import { mapActions, mapGetters } from 'vuex'
    import WorkSpaceCreateModal from "../../app/components/workspace/WorkSpaceCreateModal.vue";
    import WorkSpaceInviteDialog from "../../app/components/dialogs/WorkSpaceInviteDialog.vue";

    export default {
      name: 'Layout',
      components: {
          WorkSpaceInviteDialog,
          WorkSpaceCreateModal,
          Footer, Header, Sidebar, Notification},
      data() {
        return {
        }
      },
      created () {
        this.LOAD_IF_NOT_LOADED().then(() => {
            this.SELF_LOAD_WORK_SPACE(this.LAST_WORK_SPACE_ID);
        }).catch(error => {
            console.log(error);
            setTimeout(function () {
                window.location.reload();
            }, 1000);
        });
        this.LOAD_WORKSPACES();
        if(null != utils.getRedirectOnLogin()){
            let redirectData = {...utils.getRedirectOnLogin()}
            if(redirectData.name === 'WorkSpaceInvitePage'){
                this.SET_INVITE_WORKSPACE({invite_token: redirectData.params.token});
                this.showWorkSpaceInviteModal();
            }else {
                this.$router.push(redirectData);
            }
            utils.removeRedirectOnLogin();
        }
      },
      watch:{
        ERROR_MESSAGE_WORK_SPACE (newValue) { 
          if(null !== newValue){
              this.showError(newValue);
          }
        },
      },
      methods: {
        showError(message){
            this.SHOW_ERROR(message);
        },
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
        ...mapActions('user', ['LOAD_IF_NOT_LOADED']),
        ...mapActions('workspace', ['SELF_LOAD_WORK_SPACE']),
        ...mapActions('workspaceList', ['LOAD_WORKSPACES', 'SET_INVITE_WORKSPACE']),
        ...mapActions('dialog', ['showWorkSpaceInviteModal']),
      },
      computed:{
        ...mapGetters('user', ['IS_LOADED', 'LAST_WORK_SPACE_ID']),
        ...mapGetters('workspace', ['IS_LOAD_WORK_SPACE', 'ERROR_MESSAGE_WORK_SPACE']),
        ...mapGetters('workspaceList', ['ID_CURRENT_WORKSPACE']),

        isLoadedApp: function () {
          return this.IS_LOADED && this.IS_LOAD_WORK_SPACE;
        }
      },
    };
</script>

<style src="./Layout.scss" lang="scss" />
